import type { TFunction } from 'i18next';

import type { WorkflowSummary } from '@/api/workflows';

/**
 * FE mirror of the BE submittability gate (see WorkflowTemplate.EnsureSubmittable).
 * Today's bar: at least one step. Per-step content-completeness checks (empty
 * DynamicForm fields / empty file-entry list / empty allowed-extension list) are
 * deferred until the per-step field models settle. The BE remains the source of
 * truth; this exists so the Submit button can be disabled with a tooltip instead
 * of requiring the user to click and read an error.
 */
export type SubmitReadiness = { ok: true } | { ok: false; reason: string };

export function getSubmitReadiness(workflow: WorkflowSummary, t: TFunction): SubmitReadiness {
  // stepCount, not steps.length — the dashboard's list payload omits the step graph
  // entirely (see WorkflowSummary), and this gate runs on list rows.
  //
  // Strict `=== 0` on purpose: stepCount is null when UNKNOWN (a row predating the
  // denormalized count, read without its graph). Unknown must NOT disable Submit — the
  // BE still refuses a genuinely empty workflow, so the worst case is a click that
  // returns an error, versus a button the user can never press.
  if (workflow.stepCount === 0) {
    return { ok: false, reason: t('workflow.submitGuard.noSteps') };
  }
  return { ok: true };
}
